






import {defineComponent, onMounted, onUnmounted, reactive} from "@vue/composition-api"

export default defineComponent({
  components: {},
  props: {},
  setup(p, c) {
    const state = reactive({
      ready: false,
    })
    const listener = (e: Event) => {
      if (state.ready && !document.getElementById("autocompletePopup")!.contains(e.target as Node)) c.emit("close")
    }
    onMounted(() => window.addEventListener("click", listener))
    onUnmounted(() => window.removeEventListener("click", listener))
    // wait for click caused autocomplete show up to finish
    setTimeout(() => {
      state.ready = true
    }, 100)
    return {state}
  },
})

